module.exports = __webpack_public_path__ + "static/media/fitness.6553c33a.jpg";